<template>
  <labeled-form-control label="Email">
    <input
      v-model="clientEmail"
      class="form-control"
      type="email"
      placeholder="Enter Email"
      @focus="handleFocus"
      @blur="handleBlur"
    />
    <validation-message v-if="validator.email" :message="validator.email"/>
  </labeled-form-control>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { EmailHelper } from '@/helpers/EmailHelper'
import { StatusEmitterMixin } from '@/mixins/GeneralRegistration/StatusEmitterMixin'
import LabeledFormControl from '@/components/Layout/LabeledFormControl.vue'
import ValidationMessage from '@/components/ErrorValidation/ValidationMessage.vue'

export default {
  name: 'ClientEmailField',
  mixins: [StatusEmitterMixin],
  data () {
    return {
      validator: EmailHelper.getEmailValidator(),
      requiredFocused: false
    }
  },
  computed: {
    ...mapState('ApplicationEvents', [
      'saveClientRegistrationEvent'
    ]),
    ...mapState('ClientRegistrationUpload', [
      'email'
    ]),
    clientEmail: {
      get () {
        return this.email
      },
      set (value) {
        this.setEmail(value)
      }
    },
    validated () {
      return !!this.validator.isValid
    }
  },
  watch: {
    saveClientRegistrationEvent () {
      this.validate()
    }
  },
  methods: {
    ...mapMutations('ClientRegistrationUpload', [
      'setEmail'
    ]),
    handleFocus () {
      this.requiredFocused = true
    },
    handleBlur () {
      if (this.requiredFocused) {
        this.validate()
      }
    },
    validate () {
      this.validator.check(this.email)
    }
  },
  components: {
    'labeled-form-control': LabeledFormControl,
    'validation-message': ValidationMessage
  }
}
</script>
